<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
  <ng-container dialog-title>Add New Plan</ng-container>

  <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
    <form [formGroup]="form.formGroup" class="row add-exchange-form">
      <div [ngClass]="{'mb-3': form.controls[0].errors?.length > 0}" class="col-12">
        <app-panel-input [control]="form.controls[0]" [formControlName]="form.controls[0].name"></app-panel-input>
      </div>
      <div [ngClass]="{'mb-3': form.controls[2].errors?.length > 0}" class="col-12">
        <app-slide-toggle [control]="form.controls[2]" [formControlName]="form.controls[2].name" [textOnLeft]="true"
                            [texts]="['Is Demo', 'Is Demo']"  (ngModelChange)="form.isDemoValueChanged($event)"></app-slide-toggle>
      </div>
      <div [ngClass]="{'mb-3': form.controls[1].errors?.length > 0}" class="col-12">
        <app-autocomplete [control]="form.controls[1]" [formControlName]="form.controls[1].name"></app-autocomplete>
      </div>
    </form>
  </ng-container>
</app-dialog>